import { combineReducers } from 'redux';
import {carouselReducer as carousels} from './carouselReducer';
import { servicesReducer as services } from './servicesReducer';
export default combineReducers({carousels , services});


// WEBPACK FOOTER //
// ./src/reducers/index.js